export default __webpack_public_path__ + "static/media/download.a014434f.svg";